// Marca do sistema (nome + cor de destaque), resolvida em BUILD TIME via
// REACT_APP_BRAND (frontend/.env daquela VPS) — permite o MESMO
// código-fonte gerar um build com identidade visual diferente por
// servidor, sem nunca duplicar/forkar o projeto (decisão registrada na
// sessão de criação da 2ª VPS "É Mais Sistema", 2026-09-13).
//
// Comparação direta (em vez de indexar um objeto com as duas marcas) de
// propósito: o CRA substitui `process.env.REACT_APP_BRAND` por uma string
// literal no build de produção, e o minificador elimina o branch morto —
// assim o build de cada VPS só carrega a SUA marca no bundle, nunca o
// nome/cor da outra. Marca padrão (sem a variável, ou 'emaisgestor'): nome
// e cores continuam vindo só do index.css, como sempre — zero mudança de
// comportamento pros clientes já em produção na VPS atual.
let BRAND_NOME;
let BRAND_TITULO_ABA;
let cores;

if (process.env.REACT_APP_BRAND === 'emaissistema') {
  BRAND_NOME = 'É Mais Sistema';
  // Título da guia do navegador (AuthContext.jsx monta "<isso> - <organização>")
  // — maiúsculo de propósito, mesmo padrão do "É MAIS GESTOR" original.
  BRAND_TITULO_ABA = 'É+ SISTEMA';
  // Cor definitiva escolhida em 2026-09-17: azul, igual à paleta original
  // (índex.css) — mesma identidade visual da marca EmaisGestor, só muda o
  // nome/ícone "É+". Substituiu a paleta roxa provisória usada até então.
  //
  // Ajuste fino pedido pelo usuário em 2026-09-17 (imagem de referência do
  // dashboard/sidebar): o azul-marinho padrão (#0A1A33) ficava "quase
  // preto" e contrastava demais com o conteúdo — trocado por um navy mais
  // claro/elegante (#0B1F3A) SÓ nessa marca. Cor de destaque unificada num
  // único azul vivo (#1769FF: botões, item de menu selecionado, badge
  // "É+"), pra "conversar" com o azul da tela de Login. Os acentos
  // semânticos (verde=sucesso, laranja=atenção, vermelho=erro, roxo=info)
  // continuam intocados — são cor de INDICADOR, não de marca.
  cores = {
    '--primary':                '#1769FF',
    '--primary-dark':           '#0D47A1',
    '--primary-light':          '#EBF5FF',
    '--primary-50':             '#DBEAFE',
    '--sidebar-bg':             '#0B1F3A',
    '--sidebar-hover':          '#12345A',
    '--sidebar-active':         '#1769FF',
    '--sidebar-active-border':  '#1769FF',
    '--sidebar-text':           '#D9E5F2',
    '--sidebar-text-secondary': '#8FA6BF',
    '--sidebar-accent':         '#27AE60',
    '--border-focus':           '#32B0FF',
    '--logo-badge-bg':          '#1769FF', // badge "É+" — azul, não o verde do EmaisGestor
    // Fundo da tela de Login — diagonal azul-marinho → azul → verde-água,
    // pedido explicitamente pra essa marca (2026-09-17). O EmaisGestor
    // mantém o gradiente 100% azul original (--login-bg em index.css).
    '--login-bg': 'linear-gradient(135deg, #0A1A33 0%, #0D47A1 45%, #1565FF 65%, #14B8A6 100%)',
  };
} else {
  BRAND_NOME = 'EmaisGestor';
  BRAND_TITULO_ABA = 'É MAIS GESTOR';
  cores = null; // usa os valores já definidos em index.css
}

// Palavra curta embaixo do badge "E+" na barra lateral do PDV (layout 3).
const BRAND_SUFIXO_CURTO = process.env.REACT_APP_BRAND === 'emaissistema' ? 'SISTEMA' : 'GESTOR';
// Marca curta no topo das telas de celular (Relatórios/Reposição/Mesas).
const BRAND_MARCA_CURTA = process.env.REACT_APP_BRAND === 'emaissistema' ? 'E+ Sistema' : 'E+ Gestor';

export { BRAND_NOME, BRAND_TITULO_ABA, BRAND_SUFIXO_CURTO, BRAND_MARCA_CURTA };

// Chamar uma vez, antes do primeiro render (index.jsx) — evita "flash" da
// cor errada. Marca padrão: no-op, CSS já tem os valores certos.
export function aplicarCoresMarca() {
  if (!cores) return;
  const root = document.documentElement.style;
  for (const [variavel, valor] of Object.entries(cores)) {
    root.setProperty(variavel, valor);
  }
}

// Ícone da aba do navegador (favicon) — troca só na marca É Mais Sistema.
// public/icon.svg (verde) continua servindo o EmaisGestor sem nenhuma
// mudança; public/icon-blue.svg é a mesma arte, só com o fundo azul.
export function aplicarFaviconMarca() {
  if (process.env.REACT_APP_BRAND !== 'emaissistema') return;
  const link = document.querySelector('link[rel="icon"][href*="icon.svg"]');
  if (link) link.href = link.href.replace('icon.svg', 'icon-blue.svg');
}

// Manifest do PWA (nome/ícone que aparecem no diálogo "Instalar app" do
// navegador e no atalho gerado) — troca só na marca É Mais Sistema. Pedido
// explícito 2026-09-23: instalador tem que mostrar "É+ SISTEMA" com ícone
// azul na 2ª VPS, a 1ª VPS continua exatamente como está (manifest.json
// verde/"É MAIS GESTOR", sem nenhuma mudança). manifest-blue.json é o
// mesmo conteúdo, só trocando nome/ícones/theme_color pros azuis (ver
// public/manifest-blue.json e os ícones public/icon-blue*).
export function aplicarManifestMarca() {
  if (process.env.REACT_APP_BRAND !== 'emaissistema') return;
  const link = document.querySelector('link[rel="manifest"]');
  if (link) link.href = link.href.replace('manifest.json', 'manifest-blue.json');
  const themeColor = document.querySelector('meta[name="theme-color"]');
  if (themeColor) themeColor.content = '#1769FF';
  const appleIcon = document.querySelector('link[rel="apple-touch-icon"]');
  if (appleIcon) appleIcon.href = appleIcon.href.replace('apple-touch-icon.png', 'apple-touch-icon-blue.png');
}
